import { DishCategoryUI } from './types';

/**
 * Fetch all dish categories from the API
 */
export async function fetchDishCategories(): Promise<DishCategoryUI[]> {
  const response = await fetch('/api/dish-categories');

  if (!response.ok) {
    throw new Error('Failed to fetch dish categories');
  }

  const data = await response.json();

  // Ensure dates are properly converted to Date objects
  return data.map((category: any) => ({
    ...category,
    createdAt: new Date(category.createdAt),
    updatedAt: new Date(category.updatedAt),
  }));
}

/**
 * Fetch dish categories filtered by dish type
 */
export async function fetchDishCategoriesByType(dishType: string): Promise<DishCategoryUI[]> {
  const categories = await fetchDishCategories();
  return categories.filter((category) => category.dishType === dishType);
}
